import React from 'react';
import styled from 'styled-components/macro';

import DSPItem from './DSPItem/DSPItem';
import BlankDSPItem from './BlankDSPItem/BlankDSPItem';
import ItemPreview from './ItemPreview/ItemPreview';
import { DndProvider, DragObjectWithType } from 'react-dnd';
import { ThemeProps } from 'types/styled';
import useReorderDragDropBackend from 'hooks/useReorderDragDropBackend';

export const List = styled.ul<ThemeProps<'ul'>>`
  > li {
    ${({ isDropdownDesign, theme }): string =>
      isDropdownDesign
        ? ''
        : `
      border-top: 1px solid ${theme.LightGrey};
      &:first-child {
        border-top: 0;
      }
    `}
  }
`;

export interface IDSPInfo extends DragObjectWithType {
  id: number | string;
  name?: string;
  displayName: string;
  color?: string;
  index?: number;
}

interface ISelectedDSPListProps {
  allDSPs: IDSPInfo[];
  /** List of the selected DSPs */
  selectedDSPs: any;
  /** Method to toggle the active state of a DSP */
  toggleDSP: Function;
  /** Method that handles the order of the selected DSPs */
  changeDSPOrder: (oldIndex: number, newIndex: number) => void;
  /** Method that saves the current selectedDSPSs to redux */
  saveDSPs: () => void;
  isSourceOfStreams?: boolean;
  isDropdownDesign?: boolean;
  selectionLimit?: number;
}

/** List that displays the DSPs that are selected and ordered by the user. */
const SelectedDSPList: React.FC<ISelectedDSPListProps> = (props) => {
  const {
    allDSPs,
    selectedDSPs,
    changeDSPOrder,
    saveDSPs,
    toggleDSP,
    isSourceOfStreams,
    isDropdownDesign,
    selectionLimit = 8,
  } = props;

  const [DragDropBackend, backendOptions, isTouchDevice] =
    useReorderDragDropBackend();

  const blankDSPItems = isDropdownDesign && [
    ...Array(selectionLimit - selectedDSPs.length),
  ];

  return (
    <DndProvider backend={DragDropBackend} options={backendOptions}>
      <List isDropdownDesign={isDropdownDesign}>
        {selectedDSPs.map((dspId: any, index: number) => {
          const dspItem = allDSPs.find((dsp) =>
            isSourceOfStreams
              ? dsp.name === dspId.id
              : dsp.name === dspId || dsp.displayName === dspId
          );
          return dspItem ? (
            <DSPItem
              key={`selected-dsp-item-${dspItem.name}`}
              index={index}
              dspItem={dspItem}
              toggleDSP={toggleDSP}
              changeDSPOrder={changeDSPOrder}
              saveDSPs={saveDSPs}
              isRemovable={selectedDSPs.length > 0}
              isTouchDevice={isTouchDevice}
              isSourceOfStreams={isSourceOfStreams}
              isDropdownDesign={isDropdownDesign}
            />
          ) : null;
        })}
        {blankDSPItems &&
          blankDSPItems?.map((item, index) => (
            <BlankDSPItem
              key={`blank-dsp-item-${index}`}
              childNumber={selectedDSPs.length + 1 + index}
            />
          ))}
        {isTouchDevice && <ItemPreview key="__preview" />}
      </List>
    </DndProvider>
  );
};

export default SelectedDSPList;
